export const coreAndReturnMap = Object.freeze({
  toBeRetrieved: 'To be retrieved',
  damaged: 'Damaged',
  retrieved: 'Retrieved',
  markedReturn: 'Marked for return',
  shipped: 'Shipped',
  delivered: 'Delivered',
  refunded: 'Refunded',
});
